import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type LockIconProps = Partial<SVGIconProps>;

const LockIcon: FC<LockIconProps> = () => {
  return (
    <SVGIcon
      fill="none"
      height="19"
      viewBox="0 0 18 19"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.6123 0C9.95667 0 11.2457 0.534747 12.1963 1.48535C13.1469 2.43596 13.6816 3.72498 13.6816 5.06934V7.96484H14.8057C16.1386 7.96484 17.2197 9.04599 17.2197 10.3789V16.5752C17.2195 17.9079 16.1384 18.9883 14.8057 18.9883H2.41406C1.08128 18.9883 0.000208422 17.9079 0 16.5752V10.3789C0 9.04599 1.08115 7.96484 2.41406 7.96484H3.54297V5.06934C3.54297 3.72498 4.07771 2.43596 5.02832 1.48535C5.97893 0.534745 7.26794 8.839e-07 8.6123 0ZM2.41406 9.25195C1.79154 9.25195 1.28711 9.75638 1.28711 10.3789V16.5752C1.28732 17.1975 1.79167 17.7021 2.41406 17.7021H14.8057C15.4281 17.7021 15.9334 17.1975 15.9336 16.5752V10.3789C15.9336 9.75638 15.4282 9.25195 14.8057 9.25195H13.0479C13.0446 9.252 13.0414 9.25293 13.0381 9.25293C13.0348 9.25293 13.0316 9.252 13.0283 9.25195H4.19629C4.19304 9.252 4.18979 9.25293 4.18652 9.25293C4.18326 9.25293 4.18001 9.252 4.17676 9.25195H2.41406ZM8.6123 1.28711C7.60909 1.28711 6.64688 1.68515 5.9375 2.39453C5.22812 3.10391 4.83008 4.06612 4.83008 5.06934V7.96484H12.3945V5.06934C12.3945 4.06612 11.9965 3.10391 11.2871 2.39453C10.5777 1.68515 9.61552 1.28711 8.6123 1.28711Z"
        fill="white"
      />
    </SVGIcon>
  );
};

export default LockIcon;
